import { useCallback } from 'react';

import { useOpenNotification } from 'utils/antd/notification-toasts';
import { handleError, triggerDownload } from 'utils/download';

import { getVirtualBankStatementsFileIdDownload } from 'api';

import { useOrganisationId } from 'hooks/context';

import { TableLayout } from 'components/ui/templates/TableLayout/TableLayout';

import { DownloadExportedStatementModal } from './DownloadExportedStatementModal';
import { ExportedStatementsHeader } from './ExportedStatementsHeader';
import { ExportedStatementsTable } from './ExportedStatementsTable';
import type { FiltersState } from './localState';
import { useLocalState } from './localState';

export const ExportedStatements = () => {
  const organisationId = useOrganisationId<number>();
  const openNotification = useOpenNotification();

  const {
    state: localState,
    dispatch,
    resetState,
    setFilters: updateFilters,
    updateCursorAfter
  } = useLocalState();

  const setFilters = (value: FiltersState) => {
    dispatch(updateFilters(value));
  };

  const downloadReport = useCallback(
    async (id: number) => {
      try {
        const data = await getVirtualBankStatementsFileIdDownload(
          organisationId,
          id
        );
        triggerDownload(new Blob([data], { type: 'text/csv' }), 'report.csv');
      } catch {
        handleError(openNotification, 'Error while downloading the file');
      }
    },
    [organisationId, openNotification]
  );

  return (
    <>
      <TableLayout
        header={
          <ExportedStatementsHeader
            filters={localState.filters}
            setFilters={setFilters}
            resetState={resetState}
          />
        }
        content={
          <ExportedStatementsTable
            localState={localState}
            dispatch={dispatch}
            updateCursorAfter={updateCursorAfter}
            downloadReport={downloadReport}
          />
        }
      />
      <DownloadExportedStatementModal handleDownload={downloadReport} />
    </>
  );
};
